import { render, staticRenderFns } from "./donation.vue?vue&type=template&id=76474deb&scoped=true&lang=pug"
import script from "./donation.vue?vue&type=script&lang=js"
export * from "./donation.vue?vue&type=script&lang=js"
import style0 from "./donation.vue?vue&type=style&index=0&id=76474deb&prod&lang=scss&scoped=true"
import style1 from "./donation.vue?vue&type=style&index=1&id=76474deb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76474deb",
  null
  
)

export default component.exports